import { contact } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    email: '',
    account: '',
    name: '',
    subject: '',
    message: '',
    contactStatus: {
      loading: false,
      success: false,
      error: false,
    },
  };
};

const state = getDefaultState();

const getters = {
  getField,
};

const mutations = {
  updateField,
  updateContactStatus(state, row) {
    state.contactStatus = {
      ...state.contactStatus,
      ...row,
    };
  },
  resetState(state) {
    // state = getDefaultState()
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  tryContact({ commit }, { formData }) {
    commit('updateContactStatus', {
      loading: true,
      success: false,
      error: false,
    });
    contact(formData).then(r => {
      if (r.data.IsSuccess) {
        commit('updateContactStatus', { success: true, error: false });
      } else {
        commit('updateContactStatus', { success: false, error: true });
      }
      commit('updateContactStatus', { loading: false });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
